import { useState } from 'react';
import { Button, TeamRolePicker } from '@dataroom/shared';
import type { TeamRole } from '@dataroom/shared';
import { Modal } from './Modal';

/**
 * Edit one team member's roles (Legal, Financial, ...). Saves the whole set; an
 * empty set clears them. Presentational: the page owns the mutation.
 */
export function TeamRolesDialog({
  who,
  initial,
  pending,
  error,
  onClose,
  onSave,
}: {
  /** The person, for the title (an email). */
  who: string;
  initial: readonly TeamRole[];
  pending: boolean;
  error: string | null;
  onClose: () => void;
  onSave: (roles: TeamRole[]) => void;
}) {
  const [roles, setRoles] = useState<TeamRole[]>([...initial]);
  return (
    <Modal
      title="Team roles"
      description={`Choose the roles ${who} has on this deal.`}
      onClose={onClose}
      footer={
        <>
          {error ? <p className="text-sm text-destructive">{error}</p> : <span />}
          <div className="flex gap-2">
            <Button variant="outline" size="sm" onClick={onClose} disabled={pending}>
              Cancel
            </Button>
            <Button size="sm" disabled={pending} onClick={() => onSave(roles)}>
              {pending ? 'Saving…' : 'Save roles'}
            </Button>
          </div>
        </>
      }
    >
      <TeamRolePicker value={roles} onChange={setRoles} disabled={pending} />
    </Modal>
  );
}
